import { Logo } from "@/components/logo";
import { UserProfileMenu } from "@/components/user-profile-menu";

export function PreCallLayout({ children }: { children: React.ReactElement }) {
  return (
    <div className="h-full bg-background md:pt-24">
      <div className="left-0 right-0 top-0 w-full md:fixed">
        <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
          <Logo />

          <div>
            <UserProfileMenu />
          </div>
        </div>
      </div>
      {children}
    </div>
  );
}
